import React from "react";
import { Collapse } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";
import InfoDetail from "./InfoDetail";
const { Panel } = Collapse;

const Address = (props) => {
  const { record } = props;

  const intl = useIntl();

  //   {
  //    "apartment_number": "",
  //    "city": "אשקלון",
  //    "house_number": "0",
  //    "postal_code": "",
  //    "street": "תירוש"
  // }

  return (
    <Collapse
      bordered={false}
      defaultActiveKey={[]}
      expandIcon={({ isActive }) => (
        <CaretRightOutlined rotate={isActive ? 90 : 0} />
      )}
      className="custom-collapse-section"
    >
      <Panel
        header={intl.formatMessage({
          id: "app.leads.address",
        })}
        key={"1"}
      >
        <div>
          {record?.address?.city && (
            <InfoDetail
              title={intl.formatMessage({
                id: "app.leads.city",
              })}
              detail={record.address.city}
            />
          )}
          {record?.address?.street && (
            <InfoDetail
              title={intl.formatMessage({
                id: "app.leads.street",
              })}
              detail={record.address.street}
            />
          )}

          {record?.address?.house_number && (
            <InfoDetail
              title={intl.formatMessage({
                id: "app.leads.house_number",
              })}
              detail={record.address.house_number}
            />
          )}
          {record?.address?.apartment_number && (
            <InfoDetail
              title={intl.formatMessage({
                id: "app.leads.apartment_number",
              })}
              detail={record.address.apartment_number}
            />
          )}
          {record?.address?.postal_code && (
            <InfoDetail
              title={intl.formatMessage({
                id: "app.leads.postal_code",
              })}
              detail={record.address.postal_code}
            />
          )}
        </div>
      </Panel>
    </Collapse>
  );
};
export default Address;
